import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { clickStreamUser } from "../utils/AppUtils";
import "./SmartBarSection.scss";
import { useLocation } from "react-router-dom";
import useLogin from "../custom-hooks/useLogin";
import _ from "lodash";
import ShimmerScreen from "./Layouts/ShimmerScreen";

const SmartBarSection = (props) => {

  const location = useLocation();

  const { smartBarData, isLoading } = props;

  const navigate = useNavigate();
  const { isLoggedIn, subscribedData } = useLogin();
  const [rightStmt, setRightStmt] = useState("");

  useEffect(() => {
     // Add the class to the body when the component mounts
     document.body.classList.add('smart-bar-loaded');

     // Clean up by removing the class when the component unmounts
     return () => {
       document.body.classList.remove('smart-bar-loaded');
     };
    if (isLoggedIn) {
      if (!_.isEmpty(subscribedData)) {
        if (subscribedData.subscription_active) {
          setRightStmt(
            `You are currently on Xsel ${subscribedData.subscription_name} plan`
          );
        }
      } else {
        setRightStmt("You are currently on Free plan");
      }
    } else {
      // setRightStmt('Buying for your brokerage, instead?')
    }
  }, [isLoggedIn, subscribedData]);

  let color_code = smartBarData?.color_code;

  return (
    <section
      className="smart-bar"
      // style={{ marginLeft: "0", background: { color_code } }}
      style={{
        marginLeft: location.pathname.includes("/courseDetail/")
          ? "26.25rem"
          : "0rem",
          paddingLeft: location.pathname.includes("/courseDetail/")
          ? "0rem"
          : "0rem",  
       background: { color_code }
      }}
    >
      <div className="container">
        <div className="row">
        <div className={`${location.pathname.includes("/courseDetail/") ? "col-12 col-lg-8 course-launc-page" : "col-12 col-lg-7"}`}>
            {isLoading?<ShimmerScreen 
              case="rect"
              height="2rem"
              width="100%"
          />:<div className="smart-message">
              <span className="smart-icon">
                <img src={smartBarData?.icon_url} width={32} height={32} />
              </span>
              <span className="span-text">{smartBarData?.msg}</span>
             {  window.location.pathname.includes("subscription") ? "" :  <button
                type="button"
                className="startcourse-btn colored-btn"
                onClick={() => {
                  clickStreamUser("banner-click-btn-subscription", {});
                  navigate("/subscription");
                }}
              >
                Know More
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M4.16602 9.99981H15.8327M15.8327 9.99981L9.99935 4.16648M15.8327 9.99981L9.99935 15.8331"
                    stroke="#ffffff"
                    strokeWidth="1.66667"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button> }
            </div>}
          </div>
          <div className={`${location.pathname.includes("/courseDetail/") ? "col-12 col-lg-4  d-flex align-items-center justify-content-lg-end" : "col-12 col-lg-5  d-flex align-items-center justify-content-lg-end justify-content-center"}`}>
            <div className="smart-message text-left">
              {isLoading? <ShimmerScreen 
                case="rect"
                height="2rem"
                width="100px"
            /> :rightStmt}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default SmartBarSection;
